import React from 'react';
import styled, { keyframes } from 'styled-components/macro';
import {
  Container,
  Row,
  Col,
} from '../components/grid';
import {
  Heading3,
  Paragraph,
  LinkStyled,
} from '../components/typography';
import { TextOverlayedImage } from '../components/Image';
import SidemenuLayout from '../layout/DefaultLayout/Layouts/SidemenuLayout';
import { FaCog, FiArrowRight } from '../components/Icons';
import Aabningstider from '../layout/DefaultLayout/Footer/Aabningstider';

const Button = styled.button`
  padding: 10px 25px;
  font-weight: bold;
  font-size: 16px;
  background: ${({ theme }) => theme.colors.colorBlue};
  color: white;
  outline: none;
  text-transform: uppercase;
  display: flex;
  align-items: center;
  border: none;
  border-radius: 5px;
  transition: background 0.2s ease;
  gap: 10px;

  &:hover {
    background: ${({ theme }) => theme.hoverColors.colorBlue};
    cursor: pointer;
  }

  & > svg {
    fill: ${({ theme }) => theme.colors.colorWhite};
    font-size: 20px;
  }
`;
const SpinIcon = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;

  & > svg {
    animation: ${keyframes`
      0% {
        transform: rotate(0deg);
      }
      100% {
        transform: rotate(360deg);
      }
    `} 2s linear infinite;
  }
`;
const InputNoStyle = ({
  required,
  navn,
  tlf,
  ...otherProps
}) => <input {...otherProps} />;

const TeaxtareaNoProps = ({
  error,
  ...props
}) => <textarea {...props} />;
const basicStyles = ({ theme, error }) => `
  outline: none;
  border: 2px solid ${theme.colors.colorGreyLightAlt};
  padding: 15px;
  margin-top: 10px;
  position: relative;
  top: -15px;
  ${error && `border-color: ${theme.colors.colorRed};`}
`;
const TextareaStyled = styled(TeaxtareaNoProps)`
  ${basicStyles};
  min-height: 40px;
  resize: none;
  width: calc(100% - 34px);
  display: block;
`;
const InputStyled = styled(InputNoStyle)`
  ${basicStyles}
  height: auto;
  ${({
    navn,
    tlf,
  }) => {
    if (navn || tlf) {
      if (navn) {
        return `
          display: block;
          float: left;
          width: calc(50% - 40px);
        `;
      }
      if (tlf) {
        return `
          display: block;
          float: right;
          width: calc(50% - 40px);
        `;
      }
    }
    return `
      width: calc(100% - 34px);
      display: inline-block;
    `;
  }}
  ${({ required }) => {
    if (required) {
      return `
        background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAMAAAAp4XiDAAAAP1BMVEX/////////////////////AAD/AQL/BQX/Cwv/ERH/GRn/KCj/KSn/eHj/jo7/pab/s7P/7+//+Pj/+/v///+rGNLQAAAABXRSTlPe7u/1/lN+rPwAAABmSURBVEjH7dZJDoAwCAVQqtKJ2pH7n9UrFIxxA/uXfIYFAE5acLK0gOXkkBNnxIiR14RIRiZzzsxzn7RQVymrhrZNekRKiTD2/WDj9oj+HvwlUQRTtK8YsmaVdvxGjPxIFG/PJSYP4d250ecFN0IAAAAASUVORK5CYII=);
        background-repeat: no-repeat;
        background-size: 30px;
        background-position: right top;
      `;
    }
    return '';
  }}
`;

function validateEmail(email) {
  var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/; // eslint-disable-line
  return re.test(String(email).toLowerCase());
}

export default class Kontakt extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      name: '',
      phonenumber: '',
      email: '',
      message: '',
      submitting: false,
    };
    this.onChangeField = this.onChangeField.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
  }

  onChangeField({ target: { name, value } }) {
    this.setState({ [name]: value });
  }

  onSubmit(evt) {
    evt.preventDefault();
    evt.stopPropagation();
    const {
      name,
      phonenumber,
      email,
      message,
    } = this.state;
    if (!email) {
      window.alert('Email er påkrævet'); // eslint-disable-line
      return;
    }
    if (!validateEmail(email)) {
      window.alert('Emailen skal være gyldig'); // eslint-disable-line
      return;
    }
    if (!message) {
      window.alert('Besked er påkrævet'); // eslint-disable-line
      return;
    }
    this.setState({ submitting: true });
    window.axios.post('/api/contact', { // eslint-disable-line
      navn: name,
      telefon: phonenumber,
      email,
      besked: message,
    }).then(
      () => {
        this.setState({ submitting: false });
        this.resetFields();
        window.alert('Beskeden blev sendt'); // eslint-disable-line
        // Success
      },
    ).catch(
      () => {
        this.setState({ submitting: false });
        window.alert('Kunne ikke sende kontakt besked'); // eslint-disable-line
      },
    );
  }

  resetFields() {
    this.setState({
      name: '',
      phonenumber: '',
      email: '',
      message: '',
    });
  }

  render() {
    const {
      name,
      phonenumber,
      email,
      message,
      submitting,
    } = this.state;
    return (
      <SidemenuLayout menuPicker="OmOs" activeSidemenu="Kontakt">
        <Container white>
          <Row>
            <TextOverlayedImage height="200px" bgPos="left top" bgImage="style.kontakt2.jpg">
              &nbsp;
            </TextOverlayedImage>
          </Row>
          <Row>
            <Col xs={12} md={12} lg={8}>
              <Row>
                <Col xs={12} md={6} lg={4} padding="0 15px">
                  <Heading3 marginBottom="30px">
                    Åbningstider
                  </Heading3>
                  <Aabningstider />
                </Col>
                <Col xs={12} md={6} lg={4} padding="0 15px">
                  <Heading3 marginBottom="30px">
                    Adresse og bank
                  </Heading3>
                  <Paragraph bold>
                    Peter Skafte ApS
                  </Paragraph>
                  <Paragraph>
                    Park Allé 352A<br />
                    2605 Brøndby<br />
                    CVR: 14290400
                  </Paragraph>
                  <Paragraph>
                    Danske Bank<br />
                    Reg./konto: 4440 3557061940
                  </Paragraph>
                  <Paragraph>
                    Swift: DABADKKK<br />
                    IBAN kode:<br />
                    DK 1230003557061940
                  </Paragraph>
                </Col>
                <Col xs={12} md={6} lg={4} padding="0 15px">
                  <Heading3 marginBottom="30px">
                    Kontakt
                  </Heading3>
                  <Paragraph bold>
                    Telefon: +45 43 27 00 00
                  </Paragraph>
                  <Paragraph bold>
                    Mail:&nbsp;
                    <LinkStyled anchor to="mailto:peter@skafte.dk">
                      peter@skafte.dk
                    </LinkStyled>
                  </Paragraph>
                  <Paragraph>
                    Skriv eller ring gerne til os hvis du har nogle spørgsmål eller foreslag til forbedring.
                  </Paragraph>
                </Col>
              </Row>
            </Col>
            <Col xs={12} md={12} lg={4}>
              <Heading3 marginBottom="30px">
                Kontaktformular
              </Heading3>
              <div>
                <InputStyled navn type="text" name="name" placeholder="Navn" onChange={this.onChangeField} value={name} />
                <InputStyled tlf type="text" name="phonenumber" placeholder="Telefonnummer" onChange={this.onChangeField} value={phonenumber} />
              </div>
              <div>
                <InputStyled email required type="email" name="email" placeholder="Email" onChange={this.onChangeField} value={email} />
              </div>
              <div>
                <TextareaStyled name="message" placeholder="Besked" onChange={this.onChangeField}>
                  {message}
                </TextareaStyled>
              </div>
              <Button type="submit" onClick={this.onSubmit}>Send {submitting ? <SpinIcon><FaCog /></SpinIcon> : <FiArrowRight />}</Button>
            </Col>
          </Row>
        </Container>
      </SidemenuLayout>
    );
  }
}
